export default __webpack_public_path__ + "assets/23588fec141be1d7592164ac9d950112.png";